
export default [
  {
    path: '/erro',
    name: 'erro',
    component: () => import('../components/app/erro/Erro.vue'),
    meta: ({
      title: 'Essa página não existe... | Level Member',
    })
  },
  {
    path: '/inicio',
    name: 'inicio',
    component: () => import('../components/app/inicio/Inicio.vue'),
    meta: ({
      title: 'Buscar Clínica | OligoCheck',
    })
  },
  {
    path: '/busca',
    name: 'busca',
    component: () => import('../components/app/busca/Busca.vue'),
    meta: ({
      title: 'Busca | OligoCheck',
    })
  },
  {
    path: '/',
    name: 'mapa',
    component: () => import('../components/app/mapa/Mapa.vue'),
    meta: ({
      title: 'Mapa de Clínicas | OligoCheck',
    })
  },
  {
    path: '/pagamento',
    name: 'pagamento',
    component: () => import('../components/app/pagamento/PagamentoLink.vue'),
    meta: {
      title: 'Realizar Pagamento | OligoCheck'
    }
  },
  {
    path: '/conteudo',
    name: 'conteudo-video',
    component: () => import('../components/app/conteudo/ConteudoVideo.vue'),
    meta: {
      title: 'Conteúdo Exclusivo | OligoCheck'
    }
  },
  {
    path: '/institucional',
    name: 'institucional',
    component: () => import('../components/app/institucional/Institucional.vue'),
    meta: {
      title: 'OligoCheck | Análise Mineral'
    }
  },
  {
    path: '/mapa',
    redirect: '/'
  },
  {
    path: '/admin/login',
    name: 'admin-login',
    component: () => import('../components/admin/AdminLogin.vue'),
    meta: { title: 'Login Admin' }
  },
  {
    path: '/admin/dashboard',
    name: 'admin-dashboard',
    component: () => import('../components/admin/AdminDashboard.vue'),
    meta: { title: 'Painel Admin', requiresAuth: true }
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: "/erro"
  },
]
